import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import i18next from 'i18next';

const gqlGetDrivers = gql`
  query getDrivers($where: String, $offset: Int, $limit: Int, $order: String) {
    getDrivers(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: adrNumber
      }
      recordCount
    }
  }
`;

type Props = { collectorId?: number } & FsProps;

export const FieldSelectDriverByAdr = ({
  label = i18next.t('Αρ. Αδείας Οδηγού ADR'),
  name = 'driverId',
  defaultValues = {},
  collectorId = null,
  ...rest
}: Props) => {
  function useGetDriversLazyQuery() {
    return useLazyQuery(gqlGetDrivers, { fetchPolicy: 'no-cache' });
    //return [null, { loading: null, data: null }];
  }
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={collectorId ? JSON.stringify({ collectorId: collectorId }) : JSON.stringify({})}
      // @ts-ignore
      sbLabel={defaultValues?.adrNumber ?? undefined}
      hook={useGetDriversLazyQuery}
    />
  );
};

